import { jsx as t } from "react/jsx-runtime";
import { useNavigate as s } from "react-router-dom";
import { u as i } from "./styled-components.browser.esm-3eb04950.js";
const u = ({ link: r, isTargetBlank: a = !1, children: o }) => {
  const n = s();
  return r ? /* @__PURE__ */ t(p, { ...a ? {
    target: "_blank",
    rel: "noreferrer"
  } : {
    onClick: (e) => {
      e.preventDefault(), r && (e.ctrlKey ? window.open(r) : n(r));
    }
  }, href: r, children: o }) : /* @__PURE__ */ t("div", { children: o });
}, p = i.a`
  color: var(--primary);

    :hover {
        background-color: transparent;
    }
`;
export {
  u as TableLink
};
//# sourceMappingURL=TableLink.js.map
